import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

const ProjectModal = ({ isOpen, toggle, mode = "create", projectData = null }) => {
  const [loading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    toggle();
  };

  const getModalTitle = () => {
    switch (mode) {
      case "create":
        return "Create New Project";
      case "edit":
        return "Edit Project";
      case "view":
        return "Project Details";
      default:
        return "Project";
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{getModalTitle()}</ModalHeader>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {mode === "view" && projectData && (
            <>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>ID</Label>
                    <Input type="text" value={projectData.id || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Project ID</Label>
                    <Input type="text" value={projectData.projId || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Project Name</Label>
                    <Input type="text" value={projectData.projName || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Display Name</Label>
                    <Input type="text" value={projectData.recDisplayName || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Device ID</Label>
                    <Input type="text" value={projectData.deviceId || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Partner UUID</Label>
                    <Input type="text" value={projectData.partnerUuid || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Organization ID</Label>
                    <Input type="text" value={projectData.orgId || "-"} disabled />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <Label>Status</Label>
                    <Input type="text" value={projectData.status || "-"} disabled />
                  </FormGroup>
                </Col>
              </Row>
              {projectData.assignedAt && (
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label>Assigned At</Label>
                      <Input
                        type="text"
                        value={new Date(projectData.assignedAt).toLocaleString()}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <Label>Assigned By</Label>
                      <Input type="text" value={projectData.assignedBy || "-"} disabled />
                    </FormGroup>
                  </Col>
                </Row>
              )}
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>Created At</Label>
                    <Input
                      type="text"
                      value={new Date(projectData.createdAt).toLocaleString()}
                      disabled
                    />
                  </FormGroup>
                </Col>
                {projectData.lastUpdate && (
                  <Col md="6">
                    <FormGroup>
                      <Label>Last Update</Label>
                      <Input
                        type="text"
                        value={new Date(projectData.lastUpdate).toLocaleString()}
                        disabled
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          {mode === "view" ? (
            <Button color="secondary" onClick={toggle}>
              Close
            </Button>
          ) : (
            <>
              <Button color="secondary" onClick={toggle} disabled={loading}>
                Cancel
              </Button>
              <Button color="primary" type="submit" disabled={loading}>
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    {mode === "create" ? "Creating..." : "Updating..."}
                  </>
                ) : mode === "create" ? (
                  "Create Project"
                ) : (
                  "Update Project"
                )}
              </Button>
            </>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ProjectModal;
